import { accordionItemVariants } from './Accordion.styles';
import SvgIcon from '@/helpers/SvgIcon/SvgIcon';
import { getCSLPAttributes } from '@/utils/type-guards';
import { IBaseComponentProps } from '@/lib/types';
import { IStandardContentPageComponents } from '@/.generated';
import RichTextWrapper from '@/helpers/Wrappers/RichTextWrapper/RichTextWrapper';
import PlainTextWrapper from '@/helpers/Wrappers/PlainTextWrapper/PlainTextWrapper';

type AccordionItemProps = NonNullable<
  IStandardContentPageComponents['accordion']['accordion_items']
>[number] &
  IBaseComponentProps;

export const AccordionItem = (props: AccordionItemProps) => {
  const { uid, title, description, extendedProps, $ } = props;
  const isOpen: boolean = extendedProps?.openItemUids?.has(uid ?? '') ?? false;

  const {
    itemWrapper,
    itemButton,
    itemTitle,
    itemChevron,
    contentWrapper,
    contentInner,
    itemContent,
  } = accordionItemVariants({ isOpen });

  return (
    <li className={itemWrapper()}>
      <button
        type="button"
        data-accordion-uid={uid}
        className={itemButton()}
        onClick={(e) => extendedProps?.onToggle?.(uid ?? '', e)}
        aria-expanded={isOpen}
      >
        <PlainTextWrapper
          tag="span"
          className={itemTitle()}
          {...getCSLPAttributes($?.title)}
          content={title}
          isDangerouslySetInnerHTML
        />
        <SvgIcon icon="chevron-down" size="s" className={itemChevron()} fill="currentColor" />
      </button>
      <div className={contentWrapper()}>
        <div className={contentInner()}>
          <RichTextWrapper
            content={description}
            className={itemContent()}
            {...getCSLPAttributes($?.description)}
          />
        </div>
      </div>
    </li>
  );
};
